interface CountryFlagProps {
  countryCode: string;
  size?: number;
}

const CountryFlag = ({ countryCode, size = 20 }: CountryFlagProps) => (
  <img
    src={`https://flagcdn.com/w40/${countryCode}.png`}
    srcSet={`https://flagcdn.com/w80/${countryCode}.png 2x`}
    width={size}
    alt={countryCode.toUpperCase()}
    style={{ display: "inline-block" }}
  />
);

export default CountryFlag;
